export const projects = [
  
    {
        id: 1,
        name: 'E-learing',
        desc: "Learn and become better at your job Participate in a fully professional, social, engaging and interactive online school. Get the learning experience you deserve.",
        tool: 'ReactJS',
        color: '#03befc',
        github: 'https://github.com/Ayobami-ANDROID/E-Learning',
        view: 'https://baselinkse-learing-ayobamiandroids-projects.vercel.app/',
    },
    {
        id: 2,
        name: 'Apple Website',
        desc: 'iPhone 15 Pro is the first iPhone to feature an aerospace-grade titanium design using the same alloy that spacecrafts use for missions to Mars.',
        tool: 'ReactJS',
        color: '#03befc',
        github: 'https://github.com/Ayobami-ANDROID/Apple_website',
        view: 'https://ayobami-apple-website.vercel.app/',
    },
    {
        id: 3,
        name: "LURM ",
        desc: "search past questions by course code, Landmark University Resources Manager",
        tool: 'ReactJS',
        color: '#03befc',
        github: 'https://github.com/Ayobami-ANDROID/evangelism-unit-attendance-system',
        view: 'https://lurm.vercel.app/',
    },
    {
        id: 4,
        name: 'Gigamoni',
        desc: 'Make international transactions with ease. Get money across to family, friends, and business partners faster and easier',
        tool: 'ReactJS',
        color: '#03befc',
        github: 'https://github.com/Ayobami-ANDROID/gigamoni',
        view: 'https://gigamoni.vercel.app/',
    },
    {
        id: 5,
        name: 'Art Wave',
        desc: 'An image gallary that allows users to drag and drop images in an order of their choice. A login and register form was implemented using ReactJS and Firebase to add more interaction between the users and the gallery. A search function was also integrated to allow users to search for images in the gallery.',
        tool: 'ReactJS',
        color: '#03befc',
        github: 'https://github.com/Ayobami-ANDROID/ArtWave',
        view: 'https://art-wave-nine.vercel.app/',
    },
]